import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoPanah from "../../Picture/panah.png";
import { useNavigate } from "react-router-dom";

const OwnerCashFlow=(props)=>{
    const today = new Date().toISOString().split("T")[0];
    const [tanggalAwal,setTanggalAwal]=useState("");
    const [tanggalAkhir,setTanggalAkhir]=useState("");
    const [nilaiPemasukan,setNilaiPemasukan]=useState(0);
    const [nilaiPengeluaran,setNilaiPengeluaran]=useState(0);
    const [nilaiSaldo,setNilaiSaldo]=useState(0);
    const [tanggalAwal2,setTanggalAwal2]=useState("");
    const [tanggalAkhir2,setTanggalAkhir2]=useState("");
    const [nilaiPemasukan2,setNilaiPemasukan2]=useState(0);
    const [nilaiPengeluaran2,setNilaiPengeluaran2]=useState(0);
    const [nilaiSaldo2,setNilaiSaldo2]=useState(0);
    const [dataDetailCashflowGym1,setDataDetailCashflowGym1]=useState([]);
    const [dataDetailCashflowGym2,setDataDetailCashflowGym2]=useState([]);
    const [selectFilter,setSelectFilter]=useState("all");
    const [jsonDataDetail1,setJsonDataDetail1]=useState([]);
    const [jsonDataDetail2,setJsonDataDetail2]=useState([]);
    const url = props.url;
    const navigate=useNavigate("");

    // function format rupiah
      const formatRupiah = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);

      // function ambil data all history
      const GetDataAllHistoryPengeluaranInventoryGym =()=>{
        fetch(url + "/?op=getDataAllHistoryPengeluaranInventoryGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "dateStart=" + tanggalAwal+" 00:00:00" + "&dateFinish=" + tanggalAkhir+" 23:59:59"
    })
    .then((response) => response.json())
    .then((json)=>{
if(json!==null){
    setJsonDataDetail1(json);
const income = json.filter((item)=>item.keterangan ==="income").reduce((acc, item) => acc + parseInt(item.total), 0);
      const outcome = json.filter((item)=>item.keterangan ==="outcome").reduce((acc, item) => acc + parseInt(item.total), 0);
      const saldo = income - outcome;
      setDataDetailCashflowGym1(json);
      setNilaiPemasukan(income);
      setNilaiPengeluaran(outcome);
      setNilaiSaldo(saldo);
}else{
    setDataDetailCashflowGym1([]);
    setNilaiPemasukan(0);
    setNilaiPengeluaran(0);
    setNilaiSaldo(0);
}
      
    })
      }
      
      // function ambil data all history
      const GetDataAllHistoryPengeluaranInventoryGym2 =()=>{
        fetch(url + "/?op=getDataAllHistoryPengeluaranInventoryGym2", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "dateStart=" + tanggalAwal+" 00:00:00" + "&dateFinish=" + tanggalAkhir+" 23:59:59"
    })
    .then((response) => response.json())
    .then((json)=>{
if(json!==null){
        setJsonDataDetail2(json);
 const income = json.filter((item)=>item.keterangan ==="income").reduce((acc, item) => acc + parseInt(item.total), 0);
      const outcome = json.filter((item)=>item.keterangan ==="outcome").reduce((acc, item) => acc + parseInt(item.total), 0);
      const saldo = income - outcome;
    
      setDataDetailCashflowGym2(json);
      setNilaiPemasukan2(income);
      setNilaiPengeluaran2(outcome);
      setNilaiSaldo2(saldo);
}else{
      setDataDetailCashflowGym2([]);
setNilaiPemasukan2(0);
      setNilaiPengeluaran2(0);
      setNilaiSaldo2(0);
}
     
    })
      }
      // function select filter
      const SelectFilter=(value)=>{
        setSelectFilter(value);
 
if(value==="income"){
    
    setDataDetailCashflowGym1(jsonDataDetail1.filter((item)=>item.keterangan =="income"));
    setDataDetailCashflowGym2(jsonDataDetail2.filter((item)=>item.keterangan =="income"));
}else if(value==="outcome"){
   setDataDetailCashflowGym1(jsonDataDetail1.filter((item)=>item.keterangan ==="outcome"));
    setDataDetailCashflowGym2(jsonDataDetail2.filter((item)=>item.keterangan ==="outcome"));
}else{
     setDataDetailCashflowGym1(jsonDataDetail1.filter((item)=>item.keterangan ==="income" || item.keterangan==="outcome"));
    setDataDetailCashflowGym2(jsonDataDetail2.filter((item)=>item.keterangan ==="income" || item.keterangan==="outcome"));
}
      }
    //
    useEffect(()=>{
setTanggalAwal(today);
setTanggalAkhir(today);
    },[])
    // useEffect perubahan tanggal
      useEffect(()=>{
GetDataAllHistoryPengeluaranInventoryGym();
GetDataAllHistoryPengeluaranInventoryGym2()
      },[tanggalAwal,tanggalAkhir])

      // use effect cek session
      useEffect(()=>{
              fetch(url + "/?op=cekSession", {
                  credentials: "include", 
                })
                .then((response)=>response.json())
                .then((json)=>{
                 
                if (json === "kosong") {
                      navigate("/", { replace: true });
                    }else if(json ==="gym2"){
          navigate("/gym2", { replace: true });
                    }else if(json ==="gym1"){
          navigate("/gym1", { replace: true });
                    }
                })
              },[])
return(
    <div className={style.containerAll}>
       <div className={style.containerKiri}>
<div className={style.divTanggal}>
<input style={{cursor:"pointer"}} value={tanggalAwal} type="date" onChange={(e)=>{setTanggalAwal(e.target.value)}}/>
<div>
<img src={LogoPanah} />
</div>

<input style={{cursor:"pointer"}} value={tanggalAkhir} type="date" onChange={(e)=>{setTanggalAkhir(e.target.value)}}/>
</div>
<div className={style.divJudulContainerKiri}>
Total Cash Flow Gym 1
</div>
<div className={style.divTabelContainerKiri}>
<table className={style.tabel}>
    <thead>
<tr>
    <th>
        Item
    </th>
    <th>
        Gym
    </th>
</tr>
    </thead>
    <tbody>
<tr>
    <td>
        Pemasukan
    </td>
    <td>
        {formatRupiah(nilaiPemasukan)}
    </td>
</tr>
<tr>
    <td>
        Pengeluaran
    </td>
    <td>
 {formatRupiah(nilaiPengeluaran)}
    </td>
</tr>
<tr style={{fontWeight:"bold"}}>
    <td>
        Saldo
    </td>
    <td>
       {formatRupiah(nilaiSaldo)}
    </td>
</tr>
    </tbody>
</table>
</div>
<div className={style.divJudulContainerKiri}>
Total Cash Flow Gym 2
</div>
<div className={style.divTabelContainerKiri}>
<table className={style.tabel}>
    <thead>
<tr>
    <th>
        Item
    </th>
    <th>
        Gym
    </th>
</tr>
    </thead>
    <tbody>
<tr>
    <td>
        Pemasukan
    </td>
    <td>
        {formatRupiah(nilaiPemasukan2)}
    </td>
</tr>
<tr>
    <td>
        Pengeluaran
    </td>
    <td>
 {formatRupiah(nilaiPengeluaran2)}
    </td>
</tr>
<tr style={{fontWeight:"bold"}}>
    <td>
        Saldo
    </td>
    <td>
       {formatRupiah(nilaiSaldo2)}
    </td>
</tr>
    </tbody>
</table>
</div>
       </div>
       <div className={style.containerKanan}>
<div className={style.divFilterContainerKanan}>
Filter By Status : {<select value={selectFilter} onChange={(e)=>SelectFilter(e.target.value)}>
    <option value="all">
        all</option>
        <option value="income">
            income
        </option>
        <option value="outcome">
        outcome</option></select>}
</div>
<div className={style.divIsiContainerKanan}>
<div className={style.divIsiContainerKananKiri}>
<div>
    Detail Cash Flow Gym 1
</div>
<div >
<table className={style.tabelContainerKanan}>
    <thead>
<tr>
    <th>
        Timestamp
    </th>
    <th>
        Nama
    </th>
     <th>
        Jumlah
    </th>
     <th>
        Total
    </th>
     <th>
        Status
    </th>
</tr>
    </thead>
    <tbody>
{dataDetailCashflowGym1.map((item,index)=>(
    <tr key={index}>
<td>
    {item.timestamp}
</td>
<td>
    {item.nama_barang}
</td>
<td>
    {item.out_barang}
</td>
<td>
    {item.total}
</td>
<td>
    {item.keterangan}
</td>
    </tr>
))}
    </tbody>
</table>
</div>
</div>
<div className={style.divIsiContainerKananKanan}>
<div>
    Detail Cash Flow Gym 2
</div>
<div >
<table className={style.tabelContainerKanan}>
    <thead>
<tr>
    <th>
        Timestamp
    </th>
    <th>
        Nama
    </th>
     <th>
        Jumlah
    </th>
     <th>
        Total
    </th>
     <th>
        Status
    </th>
</tr>
    </thead>
    <tbody>
{dataDetailCashflowGym2.map((item,index)=>(
    <tr key={index}>
<td>
    {item.timestamp}
</td>
<td>
    {item.nama_barang}
</td>
<td>
    {item.out_barang}
</td>
<td>
    {item.total}
</td>
<td>
    {item.keterangan}
</td>
    </tr>
))}
    </tbody>
</table>
</div>
</div>
</div>
       </div>
    </div>
)
}
export default OwnerCashFlow;